import React, { useState } from "react";
import EmployeeList from "../Employee/index";
import API from "../Services/Employee";
import APIS from '../Services/Auth'
import DesignationList from "../Components/Designation";
import LocationList from "../Components/Location";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CenterModal from "../Components/CenterModal"

const AddEmployee = () => {
    const [empID, setEmpID] = useState("");
    const [designationId, setDesignationId] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [locationId, setLocationId] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");
    const [errors, setErrors] = useState({});
    const [selectedCenter, setSelectedCenter] = useState([]);

    const validateFields = () => {
        const errors = {};
        const regex = /^[A-Za-z]+([ .][A-Za-z]+)*$/
        // const lastNameRegex = /^[A-Za-z]+([ .][A-Za-z]+)*$/

        if (!firstName?.trim()) {
            errors.firstName = "First name is required";
        } else if (!regex.test(firstName.trim())) {
            errors.firstName = "Invalid name format";
        }
        // if (!empID.trim()) errors.empID = "Employee ID is required";
        if (!designationId.trim()) errors.designationId = "Designation is required";
        //if (!locationId.trim()) errors.locationId = "Location is required";
        if (!pincode.trim()) {
            errors.pincode = "PinCode is required";
        }
        else if (!/^\d{6}$/.test(pincode)) {
            errors.pincode = "Pincode must be 6 digits";
        }
        if (!phoneNo.trim()) {
            errors.phoneNo = "Mobile number is required";
        } else if (!/^\d{10}$/.test(phoneNo)) {
            errors.phoneNo = "Mobile number must be 10 digits";
        }
        if (!email.trim()) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            errors.email = "Invalid email format";
        }
        if (!address.trim()) errors.address = "Address is required";
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            // case "empID":
            //     setEmpID(value);
            //     break;
            case "firstName":
                setFirstName(value);
                break;
            case "lastName":
                setLastName(value);
                break;
            case "phoneNo":
                setPhoneNo(value);
                break;
            case "email":
                setEmail(value);
                break;
            case "address":
                setAddress(value);
                break;
            case "pincode":
                setPincode(value);
                // if (value.length === 6) {
                //     getCityData(value);
                // }
                if (value.length < 6) {
                    setCity("");
                    setState("");
                    return;
                }
                if (value.length === 6) {
                    getCityData(value);
                }
                break;
            case "city":
                setCity(value);
                break;
            case "state":
                setState(value);
                break;
            case "locationId":
                setLocationId(value);
                break;
            case "designationId":
                setDesignationId(value);
                break;
            default:
                break;
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        if (!selectedCenter || selectedCenter.length === 0) {
            toast.error("Please select at least one center.");
            return;
        }
        const centerlist = Array.isArray(selectedCenter)
            ? selectedCenter.join(",")
            : selectedCenter;
           // console.log('centerlist',centerlist);
        const payload = {
            // employee_id: empID,
            designation_id: parseInt(designationId),
            first_name: firstName,
            last_name: lastName,
            password: '123456',
            phone_no: phoneNo,
            email: email,
            address: address,
            location_id: centerlist,
            // location_id: locationId,
            pincode: pincode,
        };
    // console.log('pay', payload);
        try {
            const response = await API.Registration(payload);
            // console.log("response data...",response?.data)
            if (response.status === 200) {
                toast.success(response.data.message);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error("Registration failed: " + response.data.message);
            }
        } catch (error) {
            if (error.status === 403) {
                window.location.replace("/Login");
            }
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                console.error("No response received:", error.request);

            } else {
                toast.error("An unexpected error occurred. Please try again later.");
            }
        }
    };

    const handleCancel = () => {
        setTimeout(() => window.location.reload());
    }
    const getCityData = async (pincode) => {
        try {
            const response = await APIS.getCity(pincode);
            const postData = response?.data?.data;
            if (postData) {
                setCity(postData?.city_name || "");
                setState(postData?.state_name || "");
            } else {
                console.log("No city or state data found in the response.");
                toast.warning('No city or state data found in the response');
            }
        } catch (error) {
            console.error("Error fetching city data:", error.message || error);
        }
    };

    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    return (
        <div>
            <div>
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Add New Employee</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    {/* <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="city">EmpID <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtempid"
                                                placeholder="EmpID"
                                                value={empID}
                                                onChange={(e) => handleFieldChange(e, "empID")}
                                            />
                                            {errors.empID && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.empID}</span>}
                                        </div>
                                    </div> */}
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="name">First Name <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtfname"
                                                placeholder="First Name"
                                                value={firstName}
                                                onChange={(e) => handleFieldChange(e, "firstName")}
                                            />
                                            {errors.firstName && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.firstName}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="name">Last Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtlname"
                                                placeholder="Last Name"
                                                value={lastName}
                                                onChange={(e) => handleFieldChange(e, "lastName")}
                                            />
                                            {errors.lastName && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.lastName}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <DesignationList
                                            selectedDesignation={designationId}
                                            setSelectedDesignation={(designation) => {
                                                setDesignationId(designation);
                                                if (designation.trim()) {
                                                    setErrors((prevErrors) => {
                                                        const updatedErrors = { ...prevErrors };
                                                        delete updatedErrors.designationId;
                                                        return updatedErrors;
                                                    });
                                                }
                                            }}
                                        />
                                        {errors.designationId && <small className="text-danger" style={{ fontSize: "12px" }}>{errors.designationId}</small>}
                                    </div>
                                </div>
                                <div className="row">

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="email">Mobile <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtmobile"
                                                placeholder="mobile"
                                                value={phoneNo}
                                                maxLength={10}
                                                onChange={(e) => handleFieldChange(e, "phoneNo")}
                                            />
                                            {errors.phoneNo && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.phoneNo}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="email">Email <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="txtemail"
                                                placeholder="Email"
                                                value={email}
                                                onChange={(e) => handleFieldChange(e, "email")}
                                            />
                                            {errors.email && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.email}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <CenterModal onSelectCenter={handleSelectedCenter} />
                                        {errors.locationId && <small className="text-danger" style={{ fontSize: "12px" }}>{errors.locationId}</small>}
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="address">Address <span style={{ color: "red" }}>*</span></label>
                                            <textarea className="form-control" rows={1} id="txtaddress"
                                                value={address}
                                                onChange={(e) => handleFieldChange(e, "address")}
                                            ></textarea>
                                            {errors.address && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.address}</span>}
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="city">PinCode <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                maxLength={6}
                                                className="form-control"
                                                id="txtpincode"
                                                placeholder="Pin Code"
                                                value={pincode}
                                                onChange={(e) => handleFieldChange(e, "pincode")}
                                            />
                                            {errors.pincode && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.pincode}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="city">City</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtcity"
                                                placeholder="City"
                                                value={city}
                                                onChange={(e) => handleFieldChange(e, "cityId")}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="city">State</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtstate"
                                                placeholder="State"
                                                value={state}
                                                onChange={(e) => handleFieldChange(e, "stateId")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <button className="btn btn-primary me-2" onClick={handleSubmit}>Submit</button>
                                <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                {/* <button className="btn btn-light">Cancel</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmployeeList />
            <ToastContainer />
        </div>
    );
};

export default AddEmployee;
